import { render, staticRenderFns } from "./GestionCarroussel.vue?vue&type=template&id=6335d06c"
import script from "./GestionCarroussel.vue?vue&type=script&lang=js"
export * from "./GestionCarroussel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports